/**
 * @file        src/lib/docOrigin.js
 * @description Which SCREEN a document page was opened from.
 *
 *              The invoice / e-ticket / voucher pages are ONE route per product
 *              (/flight/bookings/:id/ticket, /hotel/bookings/:id/invoice, …),
 *              shared by the B2C screen and its Corporate twin. So the URL
 *              alone cannot say which sidebar group owns the page, nor which
 *              list "Back to Bookings" should return to — and both answered
 *              with the B2C half, whichever screen the admin had opened the
 *              document from.
 *
 *              This is PROVENANCE, not a filter. The document is fetched by its
 *              own booking id, so `?from=corporate` decides which nav group is
 *              open and where Back goes, and can never change WHAT is shown —
 *              it is not the `audience` URL param §9d forbids.
 * @author      Kinetika Labs
 * @created     2026-09-23
 * @changelog
 *   - 2026-09-23 Claude — Initial.
 */

export const DOC_ORIGIN_KEY = 'from';
export const CORPORATE_ORIGIN = 'corporate';

/** A document URL that remembers the screen it was opened from. */
export function docPath(path, audience) {
  if (audience !== 'b2b') return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}${DOC_ORIGIN_KEY}=${CORPORATE_ORIGIN}`;
}

/** True when this location was reached from a Corporate screen. */
export function isCorporateOrigin(search) {
  return new URLSearchParams(search || '').get(DOC_ORIGIN_KEY) === CORPORATE_ORIGIN;
}

/** The booking list "Back to Bookings" should return to. */
export function backToList(search, b2cPath, corporatePath) {
  return isCorporateOrigin(search) ? corporatePath : b2cPath;
}
